<template>
  <div class="step-submit-wrapper">
    <div><h3 class="mb-20" style="color: #1890ff;">Review & Submit</h3></div>
    <a-alert message="Please review your answers before submitting." type="info" show-icon class="mb-20" />
    
    <a-descriptions bordered :column="1" size="small" class="mb-20">
      <a-descriptions-item label="Section 1: General Data">
        <pre class="data-pre">{{ JSON.stringify(allFormData.stepA || {}, null, 2) }}</pre>
      </a-descriptions-item>
      <a-descriptions-item label="Section 2: Applied and Working (Currently Employed)">
        <pre class="data-pre">{{ JSON.stringify(allFormData.stepB || {}, null, 2) }}</pre>
      </a-descriptions-item>
      <a-descriptions-item label="Section 3: Applied and Working (Unemployed)">
        <pre class="data-pre">{{ JSON.stringify(allFormData.stepC || {}, null, 2) }}</pre>
      </a-descriptions-item>
      <a-descriptions-item label="Section 4: Further study">
        <pre class="data-pre">{{ JSON.stringify(allFormData.stepD || {}, null, 2) }}</pre>
      </a-descriptions-item>
      <a-descriptions-item label="Section 5: Suggestions">
        <pre class="data-pre">{{ JSON.stringify(allFormData.stepE || {}, null, 2) }}</pre>
      </a-descriptions-item>
      <a-descriptions-item label="MUIC Alumni Survey">
        <pre class="data-pre">{{ JSON.stringify(allFormData.stepF || {}, null, 2) }}</pre>
      </a-descriptions-item>
    </a-descriptions>

    <div class="text-right">
      <a-button-group>
        <a-button @click="backSection" type="primary"> <a-icon type="left" />Go back </a-button>
        <a-button @click="submitFinal" type="primary" class="bg-success" style="background-color: #52c41a; border-color: #52c41a;"> Submit <a-icon type="check" /> </a-button>
      </a-button-group>
    </div>
  </div>
</template>

<script>
export default {
  props: ['current', 'allFormData'],
  methods: {
    backSection() {
      this.$emit('backSection')
    },
    submitFinal() {
      // In a real app, emit to mainsurvey to call API
      this.$message.success('Form submitted successfully!');
      console.log('Final Data:', this.allFormData);
    }
  }
};
</script>

<style scoped>
.step-submit-wrapper {
  padding: 20px;
}
.data-pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
}
</style>
